import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { LS2KIDS_CONSTANTS } from "../constants";

/**
 * tlc.ls2kids.managers.seriesManager
 */
export class KidsSeriesManager {
	constructor() { }
	/**
	 * Get the series and retain them.
	 */
	static fetchSeries() {
		TLCRest.jsonCall(LS2KIDS_CONSTANTS.restUrls.series, {
			"type": TLCRest.types.POST,
			"postData": {
				"branchFilters": KidsSeriesManager._getBranchFilters(),
				"targetAudience": LS2KIDS_CONSTANTS.targetAudience,
				"applications": ["LS2KIDS"]
			},
			"callback": function (response) {
				TLCLogger.log('series', response);

				KidsSeriesManager._series = response;
				KidsSeriesManager._generateSeriesMeta();

				TLCEventManager.fireEvent(
					LS2KIDS_CONSTANTS.Events.onGetSeriesResponse,
					{
						success: true,
						data: response
					}
				);
			}
		});
	}
	/**
	 *
	 * @return {Array.<string>}
	 * @private
	 */
	static _getBranchFilters() {
		return ApplicationData.branchLimitsUtil.getLimitedBranches();
	}
	/**
	 *
	 * @return {Object.<number,tlc.ls2kids.model.series>}
	 */
	static getAllSeries() {
		return $.extend({}, KidsSeriesManager._seriesMap);
	}
	static getSeriesById(id) {
		if (KidsSeriesManager._seriesMap[id]) {
			return $.extend({}, KidsSeriesManager._seriesMap[id]);
		}

		return null;
	}
	static getSpecialImagedSeries() {
		return $.extend({}, KidsSeriesManager._seriesBySpecialImages);
	}
	/**
	 * @return {tlc.ls2kids.model.series}
	 */
	static getRandomSeries(obj) {
		if (!KidsSeriesManager.hasSeries()) {
			return;
		}

		if (!obj.items) {
			obj.items = [];
		}

		var series = {};
		var notFound = 0;

		while ((!series.logos || series.logos.length == 0 || (series.logos.length > 0 && series.logos[0].ratio >= LS2KIDS_CONSTANTS.seriesAspectRatio)) && notFound < 2) {
			if (obj.items.length == 0) {
				notFound++;
				obj.items = KidsSeriesManager._series.slice(0);
			}

			var random = Math.floor(Math.random() * (obj.items.length - 1));
			series = obj.items.splice(random, 1);
			series = series[0];
		}

		if (!series.logos || series.logos.length == 0) {
			return null;
		}

		return series;
	}
	static _generateSeriesMeta() {
		var seriesByIdMap = {};

		var style1TypeCount = 0;
		var style2TypeCount = 0;


		var allSeriesIds = [];

		var specialSeries = {
			"style1": [],
			"style2": [],
			"jackets": []
		};

		for (var i = 0, len = KidsSeriesManager._series.length; i < len; i += 1) {
			var series = KidsSeriesManager._series[i];

			seriesByIdMap[series.id] = series;
			allSeriesIds.push(series.id);

			if (series.logos && series.logos.length > 0) {
				series.types = 0;

				//			var image = series.logos.slice( Math.floor( Math.random() * series.logos.length ), 1 );
				var image = series.logos[0];

				image.ratio = image.width / image.height;

				if (image.ratio >= LS2KIDS_CONSTANTS.seriesAspectRatio) {
					specialSeries.style1.push(series.id);
					series.type = KidsSeriesManager.imageTypes.STYLE_1;

					style1TypeCount++;
				} else {
					specialSeries.style2.push(series.id);
					series.type = KidsSeriesManager.imageTypes.STYLE_2;

					style2TypeCount++;
				}
			} else {
				series.type = KidsSeriesManager.imageTypes.STYLE_JACKET;
				specialSeries.jackets.push(series.id);
			}
		}

		KidsSeriesManager._seriesBySpecialImages = specialSeries;
		KidsSeriesManager._seriesMap = seriesByIdMap;
		KidsSeriesManager._seriesIds = allSeriesIds;
	}
	/**
	 *
	 * @return {tlc.ls2kids.model.series}
	 */
	static getSeries(seriesId) {
		return KidsSeriesManager._seriesMap[seriesId];
	}
	/**
	 *
	 * @return {Array.<tlc.ls2kids.model.series>}
	 */
	static getSeriesIds() {
		return KidsSeriesManager._seriesIds.slice(0);
	}
	static hasSeries() {
		return KidsSeriesManager._series.length > 0;
	}
}
/**
 * @private
 * @type {Array.<tlc.ls2kids.model.series>}
 */
KidsSeriesManager._series = null;

/**
 * A list of series when retrieving a random series and never getting a repeated one.
 * @type {Array.<tlc.ls2kids.model.series>}
 * @private
 */
KidsSeriesManager._currentRotatedSeries = null;

/**
 * @private
 * @type {Object.<Number, tlc.ls2kids.model.series>}
 */
KidsSeriesManager._seriesMap = null;

/**
 * @private
 * @type {jQuery.Promise}
 **/
KidsSeriesManager._deferredLoad = null;


/**
 * The different types of styles a series image can have.
 * @type {Object}
 */
KidsSeriesManager.imageTypes = {
	STYLE_JACKET: 1 << 0,
	STYLE_1:      1 << 1,
	STYLE_2:      1 << 2
};

KidsSeriesManager.getSeriesEvent = LS2KIDS_CONSTANTS.Events.onGetSeries;

TLCEventManager.addListener(
	KidsSeriesManager.getSeriesEvent,

	function() {
		KidsSeriesManager.fetchSeries();
	}
);













